import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Switch,
  TextField,
  Checkbox,
} from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import {
  ClockUserIcon,
  MagnifyingGlassIcon,
  CheckSquareOffsetIcon,
  UsersThreeIcon,
  Funnel,
  FunnelX,
  Eye,
  EyeClosed,
  Tray,
} from "@phosphor-icons/react";
import { RiChatNewFill, RiChat1Fill } from "react-icons/ri";
import "remixicon/fonts/remixicon.css";

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import FilterChips from "../FilterChips";
import { Button, Snackbar, CircularProgress } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    width: "100%",
    position: "relative",
    display: "flex",
    flex: 1,
    height: "100%",
    flexDirection: "column",
    overflow: "visible",
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    padding: "0 6px",
    backgroundColor: theme.mode === "light" ? "#F0F2F5" : "#0b0b0d",
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#0c1210",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: ".5px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.25, 0.5),
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
    },

    // Específico para monitores de 11-13 polegadas
    '@media (max-width: 1366px)': {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      borderWidth: "0.5px",
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },

  tabPanelItem: {
    fontSize: 11,
    transition: "all 0.3s ease",
    fontWeight: 500,
    borderRadius: "30px",
    overflow: "visible",
    justifyContent: "center",
    textAlign: "center",
    marginLeft: "0px",
    background: "none",
    padding: "0px",
    minHeight: "40px",
    "&.Mui-selected": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "#ffffff" : "#0c1210",
      border: `1px solid ${theme.mode === "light" ? "#0067e3" : "#02B881"}`,
      boxShadow: theme.mode === "light" ? "0 2px 4px rgba(0, 0, 0, 0.05)" : "0 2px 6px 06060c",
    },
    "&:hover": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.03)" : "06060c",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: "30%",
      fontSize: 9,
      padding: theme.spacing(0.5),
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: "28%",
      fontSize: 8,
    },
  },

  tabIndicator: {
    display: "none",
  },
  tabsBadge: {

    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  bulkActionsBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 0.3s ease-in-out",
    marginBottom: 0,
    height: "56px",
    boxSizing: "border-box",
  },
  bulkActionsText: {
    fontSize: "13px",
    fontWeight: "bold",
    color: theme.mode === "light" ? "#1e3a8a" : theme.palette.primary.main,
    whiteSpace: "nowrap",
    minWidth: "50px"
  },
  bulkActionsButtonsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "6px",
    flex: 1,
    marginLeft: 8,
  },
  bulkActionButton: {
    borderRadius: "9999px",
    fontSize: "11px",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    padding: "0px",
    minWidth: "80px",
    textAlign: "center",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    transition: "background-color 0.2s",
    cursor: "pointer",
    outline: "none"
  },
  btnAccept: {
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    "&:hover": { backgroundColor: "#1d4ed8" }
  },
  btnClose: {
    backgroundColor: "#ef4444",
    color: "#fff",
    border: "none",
    "&:hover": { backgroundColor: "#dc2626" }
  },
  btnIgnore: {
    backgroundColor: theme.mode === "light" ? "#fff" : "transparent",
    color: theme.mode === "light" ? "#374151" : "#fff",
    border: `1px solid ${theme.mode === "light" ? '#d1d5db' : '#4b5563'}`,
    "&:hover": { backgroundColor: theme.mode === "light" ? "#f9fafb" : "rgba(255,255,255,0.05)" }
  },
  selectAllContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    "&:hover $selectAllText": {
      color: theme.mode === "light" ? "#1f2937" : "#f3f4f6"
    }
  },
  selectAllText: {
    fontSize: "12px",
    fontWeight: "bold",
    color: theme.mode === "light" ? "#6b7280" : "#9ca3af",
    transition: "color 0.2s"
  },
  conversationsCount: {
    fontSize: "11px",
    fontWeight: 600,
    color: theme.mode === "light" ? "#9ca3af" : "#6b7280",
  },
  ticketOptionsBox: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    background: "transparent",
    backgroundColor: "transparent",
    boxShadow: "none",
    border: "none",
    borderRadius: 0,
    //border: `1px solid ${theme.mode === "light" ? '#DCE6FF' : '#4b5563'}`,
    //boxShadow: theme.mode === "light" ? '0 1px 3px rgba(0,0,0,0.05)' : 'none',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "&.MuiPaper-root": {
      backgroundColor: "transparent !important",
      background: "transparent !important",
      boxShadow: "none !important",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "4px 6px",
      marginBottom: "4px",
    },
  },

  desktopTicketOptions: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down('sm')]: {
      display: "none",
    },
  },

  filterChipsContainer: {
    display: "flex",
    alignItems: "center",
    padding: "4px 8px 8px 8px",
    maxWidth: "100%",
    overflow: "hidden",
  },

  mobileFloatingContainer: {
    display: "none",
    [theme.breakpoints.down('sm')]: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      bottom: 95, // 20px (bottom do nav) + 65px (altura do nav) + 10px (espaçamento)
      right: 16,
      zIndex: 999,
      alignItems: "center",
      gap: 10,
    },
  },

  floatingOptionButton: {
    width: 40,
    height: 40,
    minWidth: 40,
    minHeight: 40,
    borderRadius: 8,
    border: `1px solid ${theme.mode === "light" ? "#e5e7eb" : "#4b5563"}`,
    backgroundColor: theme.mode === "light" ? "#ffffff" : theme.palette.background.paper,
    color: theme.mode === "light" ? "#6b7280" : "#ededed",
    boxShadow: theme.mode === "light" ? "0 2px 5px rgba(0,0,0,0.08)" : "0 2px 5px rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    outline: "none",
    padding: 0,
    flexShrink: 0,
    transition: "all 0.2s ease",
    "&:hover": {
      opacity: 0.9,
    },
  },

  floatingOptionButtonSelected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.contrastText || "#ffffff"} !important`,
    borderColor: `${theme.palette.primary.main} !important`,
    boxShadow: `0 2px 6px ${theme.palette.primary.main}66`,
  },

  floatingOptionIcon: {
    fontSize: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "inherit",
  },

  queueSelect: {
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "0",
    width: "40%",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
    },
    "& .MuiFormControl-root": {
      margin: 0,
    },
    "& .MuiInputBase-root": {
      backgroundColor: theme.mode === "light" ? "transparent" : "#0b0b0d",
      borderRadius: 10,
      border: `1px solid ${theme.mode === "light" ? '#ededed' : '#4b5563'}`,
      color: theme.mode === "light" ? "#1f2937" : "#ededed",
      padding: "2px 8px",
      "&::before, &::after": { display: "none" }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none", // Remove a borda nativa sobreposta do Material UI
    },
    "& .MuiInputLabel-root": {
      color: theme.mode === "light" ? "#6b7280" : "#4a546b",
    },
    "& .MuiChip-root": {
      backgroundColor: theme.mode === "light" ? "#e5e7eb" : "#06060c",
      color: theme.mode === "light" ? "#1f2937" : "#ededed",
      border: `1px solid ${theme.mode === "light" ? 'transparent' : '#4b5563'}`,
    },
    "& .MuiSvgIcon-root": {
      color: theme.mode === "light" ? "#6b7280" : "#4a546b",
    }
  },

  serachInputWrapper: {
    height: 40,
    background: theme.mode === "light" ? "#ffffff" : "#0b0b0d",
    display: "flex",
    borderRadius: 8,
    padding: 4,
    //border: `1px solid ${theme.mode === "light" ? '#f3f4f6' : '#4b5563'}`,
    //boxShadow: theme.mode === "light" ? '0 1px 3px rgba(0,0,0,0.05)' : 'none',
    marginTop: "8px",
    marginBottom: "8px",
    marginLeft: "0",
    marginRight: "0",
  },

  searchIcon: {
    color: theme.mode === "light" ? "#9ca3af" : "#6b7280",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
    color: theme.mode === "light" ? "#1f2937" : "#ededed",
    "& input::placeholder": {
      color: theme.mode === "light" ? "#9ca3af" : "#4a546b",
      opacity: 1,
    }
  },

  badge: {
    // right: "-10px",
  },

  customBadge: {
    right: "-90px",
    top: "-12px",
    transform: "translate(30%, -30%)",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: "10px",
    padding: "0 6px",
    fontWeight: "bold",
    fontSize: "0.75rem",
    minWidth: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  },

  modernTabs: {
    backgroundColor: theme.mode === "light" ? "#DCE6FF" : "#0A0A0B",
    padding: "4px",
    width: "auto",
    minHeight: 40,
    borderRadius: 30,
    margin: "0 0",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "visible",
    alignItems: "center",
    "& .MuiTabs-scroller": {
      overflow: "visible !important",
    },
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {
    marginRight: 6,
    alignSelf: "center",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
  },
  button: {
    height: 30,
    width: 30,
    border: "1px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  // Botão de Novo Ticket com cor personalizada
  newTicketButton: {
    height: 30,
    width: 40,
    minWidth: 30,
    minHeight: 30,
    flexShrink: 0,
    border: "none",
    backgroundColor: "#0046F9",
    borderRadius: 25,
    marginRight: 8,
    padding: 0,
    boxShadow: "0 1px 3px rgba(0, 70, 249, 0.3)",
    cursor: "pointer",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#0038c7",
      boxShadow: "0 2px 6px rgba(0, 70, 249, 0.45)",
    },
    [theme.breakpoints.down('sm')]: {
      height: 28,
      width: 28,
      minWidth: 28,
      minHeight: 28,
      marginRight: 6,
    },
    '@media (max-width: 1366px)': {
      height: 28,
      width: 28,
      minWidth: 28,
      minHeight: 28,
      marginRight: 6,
    },
  },
  newTicketIcon: {
    color: "#ffffff",
    fontSize: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  // Classe padronizada para todos os botões de ação
  standardButton: {
    height: 30,
    width: 30,
    minWidth: 30,
    minHeight: 30,
    flexShrink: 0,
    border: `1px solid ${theme.mode === "light" ? '#e5e7eb' : '#4b5563'}`,
    backgroundColor: theme.mode === "light" ? "#ffffff" : "transparent",
    borderRadius: 10,
    marginRight: 8,
    padding: 0,
    boxShadow: theme.mode === "light" ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
    cursor: "pointer",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      backgroundColor: theme.mode === "light" ? "#f9fafb" : "rgba(255, 255, 255, 0.05)",
    },
    [theme.breakpoints.down('sm')]: {
      height: 28,
      width: 28,
      minWidth: 28,
      minHeight: 28,
      marginRight: 6,
    },
    // Ajuste para monitores pequenos (11-13 polegadas)
    '@media (max-width: 1366px)': {
      height: 28,
      width: 28,
      minWidth: 28,
      minHeight: 28,
      marginRight: 6,
    },
  },
  standardButtonWithText: {
    height: 32,
    minHeight: 30,
    width: "120px",
    minWidth: "auto",
    flexShrink: 0,
    border: `1px solid ${theme.mode === "light" ? '#DCE6FF' : '#4b5563'}`,
    backgroundColor: theme.mode === "light" ? "#FEFEFF" : "transparent",
    borderRadius: 18,
    marginRight: 2,
    padding: "0 10px",
    boxShadow: theme.mode === "light" ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
    cursor: "pointer",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    textTransform: "none",
    letterSpacing: "normal",
    lineHeight: "normal",
    transition: "all 0.2s ease",
    "&.Mui-selected": {
      backgroundColor: theme.mode === "light" ? "transparent" : "transparent",
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      "&:hover": {
        backgroundColor: theme.mode === "light" ? "#f9fafb" : "rgba(255, 255, 255, 0.05)",
      },
    },
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      backgroundColor: theme.mode === "light" ? "#f9fafb" : "rgba(255, 255, 255, 0.05)",
    },
    [theme.breakpoints.down('sm')]: {
      height: 28,
      minHeight: 28,
      marginRight: 6,
      padding: "0 8px",
      gap: 4,
    },
    '@media (max-width: 1366px)': {
      height: 28,
      minHeight: 28,
      marginRight: 6,
      padding: "0 8px",
      gap: 4,
    },
  },
  buttonLabel: {
    fontSize: 12,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: theme.mode === "light" ? "#6b7280" : "#ededed",
    transition: "color 0.2s ease",
    [theme.breakpoints.down('sm')]: {
      fontSize: 11,
    },
    '@media (max-width: 1366px)': {
      fontSize: 11,
    },
  },
  activeButtonLabel: {
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    fontWeight: 600,
  },
  activeButton: {
    backgroundColor: theme.mode === "light" ? "#DBE5FF" : "transparent",
    borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    borderWidth: "1px",
  },
  standardIcon: {
    color: theme.mode === "light" ? "#6b7280" : "#4a546b",
    fontSize: 18,
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  activeIcon: {
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [selectedTickets, setSelectedTickets] = useState([]);

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedTagObjects, setSelectedTagObjects] = useState([]);
  const [selectedUserObjects, setSelectedUserObjects] = useState([]);
  const [selectedWhatsappObjects, setSelectedWhatsappObjects] = useState([]);
  const [selectedStatusObjects, setSelectedStatusObjects] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);

  const [isFilterActive, setIsFilterActive] = useState(false);

  // Estados Draft para controle de ação no Botão Filtrar
  const [draftTags, setDraftTags] = useState([]);
  const [draftTagObjects, setDraftTagObjects] = useState([]);
  const [draftUsers, setDraftUsers] = useState([]);
  const [draftUserObjects, setDraftUserObjects] = useState([]);
  const [draftWhatsapp, setDraftWhatsapp] = useState([]);
  const [draftWhatsappObjects, setDraftWhatsappObjects] = useState([]);
  const [draftStatus, setDraftStatus] = useState([]);
  const [draftStatusObjects, setDraftStatusObjects] = useState([]);
  const [draftDateStart, setDraftDateStart] = useState("");
  const [draftDateEnd, setDraftDateEnd] = useState("");
  const [isApplyingFilters, setIsApplyingFilters] = useState(false);

  const [currentTicketIds, setCurrentTicketIds] = useState({
    open: [],
    pending: [],
    group: [],
    closed: [],
    search: []
  });

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(!forceSearch);
  }, [tab]);

  useEffect(() => {
    if (user.viewAllConnections === 'disabled' && profile !== 'admin') {
      setSelectedWhatsapp([]);
      setDraftWhatsapp([]);
    }
  }, [user.viewAllConnections, profile]);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
      setTab("open");
      return;
    } else if (tab !== "search") {
      handleFilter();
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };


  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleBulkClose = async () => {
    for (const id of selectedTickets) {
      await api.put(`/tickets/${id}`, { status: "closed", userId: user?.id || null });
    }
    setSelectedTickets([]);
  };

  const handleBulkAccept = async () => {
    for (const id of selectedTickets) {
      await api.put(`/tickets/${id}`, { status: "open", userId: user?.id });
    }
    setSelectedTickets([]);
  };

  const handleBulkIgnore = async () => {
    for (const id of selectedTickets) {
      await api.put(`/tickets/${id}`, { status: "closed", userId: user?.id || null, sendFarewellMessage: false });
    }
    setSelectedTickets([]);
  };

  const handleTicketsLoaded = useCallback((status, ids) => {
    setCurrentTicketIds(prev => {
      if (JSON.stringify(prev[status]) === JSON.stringify(ids)) return prev;
      return { ...prev, [status]: ids };
    });
  }, []);

  const currentActiveTab = tab === "search" ? "search" : (tab === "closed" ? "closed" : tabOpen);
  const currentTabTicketIds = currentTicketIds[currentActiveTab] || [];
  const isAllSelected = currentTabTicketIds.length > 0 && currentTabTicketIds.every(id => selectedTickets.includes(id));

  // Limpa a seleção sempre que o usuário trocar de aba principal ou sub-aba
  useEffect(() => {
    setSelectedTickets([]);
  }, [tab, tabOpen]);

  const handleSelectAll = () => {
    if (currentTabTicketIds.length === 0) return; // Bloqueia a ação se não houver tickets

    if (isAllSelected) {
      setSelectedTickets([]);
    } else {
      const newSelected = Array.from(new Set([...selectedTickets, ...currentTabTicketIds]));
      setSelectedTickets(newSelected);
    }
  };

  /*const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };*/

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleApplyFilters = () => {
    setIsApplyingFilters(true);
    setSelectedTags(draftTags);
    setSelectedTagObjects(draftTagObjects);
    setSelectedUsers(draftUsers);
    setSelectedUserObjects(draftUserObjects);
    setSelectedWhatsapp(draftWhatsapp);
    setSelectedWhatsappObjects(draftWhatsappObjects);
    setSelectedStatus(draftStatus);
    setSelectedStatusObjects(draftStatusObjects);
    setDateStart(draftDateStart);
    setDateEnd(draftDateEnd);
    setForceSearch((prev) => !prev);
    setFilter(false);
    setIsFilterActive(false);
    setTimeout(() => setIsApplyingFilters(false), 800);
  };

  // Helper to remove a specific filter value
  const removeFilter = (key, type) => {
    switch (type) {
      case "tag":
        setDraftTags((prev) => prev.filter((id) => id !== key));
        setDraftTagObjects((prev) => prev.filter((t) => t.id !== key));
        setSelectedTags((prev) => prev.filter((id) => id !== key));
        setSelectedTagObjects((prev) => prev.filter((t) => t.id !== key));
        break;
      case "user":
        setDraftUsers((prev) => prev.filter((id) => id !== key));
        setDraftUserObjects((prev) => prev.filter((u) => u.id !== key));
        setSelectedUsers((prev) => prev.filter((id) => id !== key));
        setSelectedUserObjects((prev) => prev.filter((u) => u.id !== key));
        break;
      case "whatsapp":
        setDraftWhatsapp((prev) => prev.filter((id) => id !== key));
        setDraftWhatsappObjects((prev) => prev.filter((w) => w.id !== key));
        setSelectedWhatsapp((prev) => prev.filter((id) => id !== key));
        setSelectedWhatsappObjects((prev) => prev.filter((w) => w.id !== key));
        break;
      case "status":
        setDraftStatus((prev) => prev.filter((s) => s !== key));
        setDraftStatusObjects((prev) => prev.filter((s) => s.status !== key));
        setSelectedStatus((prev) => prev.filter((s) => s !== key));
        setSelectedStatusObjects((prev) => prev.filter((s) => s.status !== key));
        break;
      case "dateStart":
        setDraftDateStart("");
        setDateStart("");
        break;
      case "dateEnd":
        setDraftDateEnd("");
        setDateEnd("");
        break;
      default:
        break;
    }
    setForceSearch((prev) => !prev);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setIsFilterActive(false);
    } else {
      setFilter(true);
      setIsFilterActive(true);
    }
  };

  const renderBulkActionsBox = () => (
    <div
      className={classes.bulkActionsBox}
      style={selectedTickets.length > 0 ? {
        backgroundColor: theme.mode === "light" ? "#f0f9ff" : "rgba(59, 130, 246, 0.1)",
        //border: `1px solid ${theme.mode === "light" ? '#bfdbfe' : theme.palette.primary.main}`,
        padding: "12px 16px",
        borderRadius: 12
      } : {
        backgroundColor: "transparent",
        border: "1px solid transparent",
        padding: "4px 8px",
        borderRadius: 0
      }}
    >
      <div
        className={classes.selectAllContainer}
        onClick={currentTabTicketIds.length > 0 ? handleSelectAll : undefined}
        style={{ opacity: currentTabTicketIds.length > 0 ? 1 : 0.5, cursor: currentTabTicketIds.length > 0 ? 'pointer' : 'default' }}
      >
        <Checkbox
          checked={isAllSelected}
          onChange={currentTabTicketIds.length > 0 ? handleSelectAll : undefined}
          disabled={currentTabTicketIds.length === 0}
          color="primary"
          size="small"
          style={{ padding: 0 }}
        />
        <span className={classes.selectAllText} style={selectedTickets.length > 0 ? { color: theme.mode === "light" ? "#1e3a8a" : theme.palette.primary.main } : {}}>
          {selectedTickets.length > 0 ? `${selectedTickets.length} selec.` : "Selecionar tudo"}
        </span>
      </div>

      {selectedTickets.length > 0 ? (
        <div className={classes.bulkActionsButtonsContainer}>
          {tab !== "closed" && (tab === "search" || tabOpen !== "open") && (
            <button className={`${classes.bulkActionButton} ${classes.btnAccept}`} onClick={handleBulkAccept}>{i18n.t("ticketsList.buttons.accept")}</button>
          )}
          {tab !== "closed" && (
            <button className={`${classes.bulkActionButton} ${classes.btnClose}`} onClick={handleBulkClose}>{i18n.t("ticketsList.buttons.closed")}</button>
          )}
          {tab !== "closed" && (tab === "search" || tabOpen !== "open") && (
            <button className={`${classes.bulkActionButton} ${classes.btnIgnore}`} onClick={handleBulkIgnore}>{i18n.t("ticketsList.buttons.ignore")}</button>
          )}
        </div>
      ) : (
        <span className={classes.conversationsCount}>
          {tab === "search" ? 0 : tabOpen === "open" ? openCount : tabOpen === "pending" ? pendingCount : groupingCount} conversas
        </span>
      )}
    </div>
  );
  
  const commonFilterProps = {
    searchParam,
    tags: selectedTags,
    users: selectedUsers,
    whatsappIds: selectedWhatsapp,
    statusFilter: selectedStatus,
    dateStart,
    dateEnd,
    forceSearch,
    searchOnMessages
  };

  return (
    <Paper square className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <div className={classes.serachInputWrapper}>
        <MagnifyingGlassIcon className={classes.searchIcon} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
        />
        <Tooltip placement="top" title="Marque para pesquisar também nos conteúdos das mensagens (mais lento)">
          <div>
            <Switch
              size="small"
              checked={searchOnMessages}
              onChange={(e) => { setSearchOnMessages(e.target.checked) }}
            />
          </div>
        </Tooltip>
        <IconButton
          style={{
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            borderRadius: "50%",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          variant="contained"
          aria-label="filter"
          className={classes.filterIcon}
          onClick={() => {
            setIsFilterActive((prevState) => !prevState);
            handleFilter();
          }}
        >
          {isFilterActive ? (
            <Funnel weight="fill" className={classes.icon} />
          ) : (
            <FunnelX className={classes.icon} />
          )}
        </IconButton>
      </div>

      {filter === true && (
        <Paper elevation={0} style={{ padding: 12, margin: "8px 6px", borderRadius: 8, border: `1px solid ${theme.mode === "light" ? '#e5e7eb' : '#333'}`}}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TagsFilter
                onFiltered={(s) => {
                  setDraftTags(s.map((t) => t.id));
                  setDraftTagObjects(s);
                }}
              />
            </Grid>
            {(user.viewAllConnections === 'enabled' || profile === "admin") && (
              <Grid item xs={12}>
                <WhatsappsFilter
                  onFiltered={(s) => {
                    setDraftWhatsapp(s.map((t) => t.id));
                    setDraftWhatsappObjects(s);
                  }}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <StatusFilter
                onFiltered={(s) => {
                  setDraftStatus(s.map((t) => t.status));
                  setDraftStatusObjects(s);
                }}
              />
            </Grid>
            {profile === "admin" && (
              <Grid item xs={12}>
                <UsersFilter
                  onFiltered={(s) => {
                    setDraftUsers(s.map((t) => t.id));
                    setDraftUserObjects(s);
                  }}
                />
              </Grid>
            )}
            <Grid item xs={12} style={{ display: 'flex', gap: '6px', alignItems: 'center', marginTop: '4px' }}>
              <TextField
                label="Início"
                type="date"
                value={draftDateStart}
                onChange={(e) => setDraftDateStart(e.target.value)}
                InputLabelProps={{ shrink: true }}
                size="small"
                variant="outlined"
                style={{ flex: 1 }}
              />
              <TextField
                label="Fim"
                type="date"
                value={draftDateEnd}
                onChange={(e) => setDraftDateEnd(e.target.value)}
                InputLabelProps={{ shrink: true }}
                size="small"
                variant="outlined"
                style={{ flex: 1 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleApplyFilters}
                disabled={isApplyingFilters}
                style={{ minWidth: '90px', height: '40px', padding: '0 8px' }}
              >
                {isApplyingFilters ? <CircularProgress size={20} color="inherit" /> : "Aplicar"}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}

      <div className={classes.ticketOptionsBox}>
        <div className={classes.desktopTicketOptions}>
          <Badge
            color="primary"
            invisible={
              isHoveredAll ||
              !isHoveredNew ||
              isHoveredResolve ||
              isHoveredOpen ||
              isHoveredClosed
            }
            badgeContent={i18n.t("tickets.inbox.newTicket")}
            classes={{ badge: classes.tabsBadge }}
          >
            <button
              onMouseEnter={() => setIsHoveredNew(true)}
              onMouseLeave={() => setIsHoveredNew(false)}
              className={classes.newTicketButton}
              onClick={() => {
                setNewTicketModalOpen(true);
              }}
            >
              <RiChatNewFill className={classes.newTicketIcon} size={18} />
            </button>
          </Badge>
          <Can
            role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
            perform="tickets-manager:showall"
            yes={() => (
              <ToggleButton style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}
                onMouseEnter={() => setIsHoveredAll(true)}
                onMouseLeave={() => setIsHoveredAll(false)}
                className={`${classes.standardButtonWithText} ${(showAllTickets || isHoveredAll) ? classes.activeButton : ''}`}
                value="uncheck"
                selected={showAllTickets}
                onChange={() => setShowAllTickets((prevState) => !prevState)}
              >
                {showAllTickets ? (
                  <Eye weight="bold" className={`${classes.standardIcon} ${classes.activeIcon}`} />
                ) : (
                  <EyeClosed weight="bold" className={`${classes.standardIcon} ${isHoveredAll ? classes.activeIcon : ''}`} />
                )}
                <span className={`${classes.buttonLabel} ${(showAllTickets || isHoveredAll) ? classes.activeButtonLabel : ''}`}>
                  Ver tudo
                </span>
              </ToggleButton>
            )}
          />
          <Snackbar
            open={snackbarOpen}
            onClose={handleSnackbarClose}
            message={i18n.t("tickets.inbox.closedAllTickets")}
            ContentProps={{
              className: classes.snackbar,
            }}
            action={
              <>
                <Button
                  className={classes.yesButton}
                  size="small"
                //onClick={CloseAllTicket}
                >
                  {i18n.t("tickets.inbox.yes")}
                </Button>
                <Button
                  className={classes.noButton}
                  size="small"
                  onClick={handleSnackbarClose}
                >
                  {i18n.t("tickets.inbox.no")}
                </Button>
              </>
            }
          />
          {/* Botão "Abertos" */}
          <button
            onMouseEnter={() => {
              setIsHoveredOpen(true);
              setHoveredButton("open");
            }}
            onMouseLeave={() => {
              setIsHoveredOpen(false);
              setHoveredButton(null);
            }}
            className={`${classes.standardButtonWithText} ${(tab === "open" || isHoveredOpen) ? classes.activeButton : ''}`}
            onClick={() => handleChangeTab(null, "open")}
          >
            <Tray
              weight="bold"
              className={`${classes.standardIcon} ${(tab === "open" || isHoveredOpen) ? classes.activeIcon : ''}`}
            />
            <span className={`${classes.buttonLabel} ${(tab === "open" || isHoveredOpen) ? classes.activeButtonLabel : ''}`}>
              Aberto
            </span>
          </button> 

          {/* Botão "Resolvidos" */}
          <button
            onMouseEnter={() => {
              setIsHoveredClosed(true);
              setHoveredButton("closed");
            }}
            onMouseLeave={() => {
              setIsHoveredClosed(false);
              setHoveredButton(null);
            }}
            className={`${classes.standardButtonWithText} ${(tab === "closed" || isHoveredClosed) ? classes.activeButton : ''}`}
            onClick={() => handleChangeTab(null, "closed")}
          >
            <CheckSquareOffsetIcon
              weight="bold"
              className={`${classes.standardIcon} ${(tab === "closed" || isHoveredClosed) ? classes.activeIcon : ''}`}
            />
            <span className={`${classes.buttonLabel} ${(tab === "closed" || isHoveredClosed) ? classes.activeButtonLabel : ''}`}>
              Resolvidos
            </span>
          </button>
        </div>

        {/* Movido o seletor de filas para a mesma linha dos botões - Ocultado conforme solicitado */}
        <div className={classes.queueSelect} style={{ display: "none" }}>
          <TicketsQueueSelect
            selectedQueueIds={selectedQueueIds}
            userQueues={user?.queues}
            onChange={(values) => setSelectedQueueIds(values)}
          />
        </div>
      </div>

      {/* Botões flutuantes mobile no canto inferior direito acima do menu suspenso */}
      <div className={classes.mobileFloatingContainer}>
        <Can
          role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
          perform="tickets-manager:showall"
          yes={() => (
            <button
              type="button"
              className={clsx(
                classes.floatingOptionButton,
                showAllTickets && classes.floatingOptionButtonSelected
              )}
              onClick={() => setShowAllTickets((prevState) => !prevState)}
              title="Ver tudo"
            >
              {showAllTickets ? (
                <Eye weight="bold" size={18} className={classes.floatingOptionIcon} />
              ) : (
                <EyeClosed weight="bold" size={18} className={classes.floatingOptionIcon} />
              )}
            </button>
          )}
        />
        <button
          type="button"
          className={clsx(
            classes.floatingOptionButton,
            tab === "open" && classes.floatingOptionButtonSelected
          )}
          onClick={() => handleChangeTab(null, "open")}
          title="Abertos"
        >
          <Tray weight="bold" size={18} className={classes.floatingOptionIcon} />
        </button>
        <button
          type="button"
          className={clsx(
            classes.floatingOptionButton,
            tab === "closed" && classes.floatingOptionButtonSelected
          )}
          onClick={() => handleChangeTab(null, "closed")}
          title="Resolvidos"
        >
          <CheckSquareOffsetIcon weight="bold" size={18} className={classes.floatingOptionIcon} />
        </button>
        <button
          type="button"
          className={clsx(
            classes.floatingOptionButton,
            newTicketModalOpen && classes.floatingOptionButtonSelected
          )}
          onClick={() => setNewTicketModalOpen(true)}
          title="Novo Ticket"
        >
          <RiChatNewFill size={18} className={classes.floatingOptionIcon} />
        </button>
      </div>

      <TabPanel value={tab} name="open"  style={{ padding: "0" }}>
        {Boolean(
          selectedTags.length > 0 ||
          selectedUsers.length > 0 ||
          selectedWhatsapp.length > 0 ||
          selectedStatus.length > 0 ||
          dateStart ||
          dateEnd
        ) && (
          <div className={classes.filterChipsContainer}>
            <FilterChips
              selectedTags={selectedTagObjects}
              selectedUsers={selectedUserObjects}
              selectedWhatsapp={selectedWhatsappObjects}
              selectedStatus={selectedStatusObjects}
              dateStart={dateStart}
              dateEnd={dateEnd}
              onRemove={removeFilter}
              openFilter={() => {
                setFilter(true);
                setIsFilterActive(true);
              }}
            />
          </div>
        )}
        <Tabs
          value={["open", "pending", "group"].includes(tabOpen) ? tabOpen : false}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          alignItems="center"
          variant="fullWidth"
          scrollButtons="auto"
          TabIndicatorProps={{ className: classes.tabIndicator }}
          className={classes.modernTabs}
        >
          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" marginLeft="4px" justifyContent="center" style={{ position: "relative", paddingTop: 0 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={openCount}
                    color="primary"
                  >

                    <RiChat1Fill
                      size={20}
                      weight="fill"
                      style={{
                        color: tabOpen === "open" ? theme.palette.primary.main : (theme.mode === "light" ? "#2F487A" : "#4a546b"),
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 12,
                      fontWeight: tabOpen === "open" ? 600 : 600,
                      color: tabOpen === "open" ? theme.palette.primary.main : (theme.mode === "light" ? "#2F487A" : "#4a546b"),
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" marginLeft="4px" justifyContent="center" style={{ position: "relative", paddingTop: 0 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={pendingCount}
                    color="primary"
                  >
                    <ClockUserIcon
                      size={20}
                      weight="fill"
                      style={{
                        fontSize: 20,
                        color: tabOpen === "pending" ? theme.palette.primary.main : (theme.mode === "light" ? "#2F487A" : "#4a546b"),
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 12,
                      fontWeight: tabOpen === "pending" ? 600 : 600,
                      color: tabOpen === "pending" ? theme.palette.primary.main : (theme.mode === "light" ? "#2F487A" : "#4a546b"),
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" marginLeft="4px" justifyContent="center" style={{ position: "relative", paddingTop: 0 }}>
                  <Grid item>
                    <Badge
                      overlap="circular"
                      max={999}
                      classes={{ badge: classes.customBadge }}
                      badgeContent={groupingCount}
                      color="primary"
                    >
                      <UsersThreeIcon
                        size={20}
                        weight="fill"
                        style={{
                          color: tabOpen === "group" ? theme.palette.primary.main : (theme.mode === "light" ? "#2F487A" : "#4a546b"),
                        }}
                      />
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 12,
                        fontWeight: tabOpen === "group" ? 600 : 600,
                        color: tabOpen === "group" ? theme.palette.primary.main : (theme.mode === "light" ? "#2F487A" : "#4a546b"),
                        transition: "all 0.2s ease",
                      }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}
        </Tabs>

        {renderBulkActionsBox()}

        <Paper square className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
            selectedTickets={selectedTickets}
            setSelectedTickets={setSelectedTickets}
            onTicketsLoaded={(ids) => handleTicketsLoaded("open", ids)}
            {...commonFilterProps}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
            selectedTickets={selectedTickets}
            setSelectedTickets={setSelectedTickets}
            onTicketsLoaded={(ids) => handleTicketsLoaded("pending", ids)}
            {...commonFilterProps}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
              selectedTickets={selectedTickets}
              setSelectedTickets={setSelectedTickets}
              onTicketsLoaded={(ids) => handleTicketsLoaded("group", ids)}
              {...commonFilterProps}
            />
          )}
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        {Boolean(
          selectedTags.length > 0 ||
          selectedUsers.length > 0 ||
          selectedWhatsapp.length > 0 ||
          selectedStatus.length > 0 ||
          dateStart ||
          dateEnd
        ) && (
          <div className={classes.filterChipsContainer}>
            <FilterChips
              selectedTags={selectedTagObjects}
              selectedUsers={selectedUserObjects}
              selectedWhatsapp={selectedWhatsappObjects}
              selectedStatus={selectedStatusObjects}
              dateStart={dateStart}
              dateEnd={dateEnd}
              onRemove={removeFilter}
              openFilter={() => {
                setFilter(true);
                setIsFilterActive(true);
              }}
            />
          </div>
        )}
        {renderBulkActionsBox()}
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
          selectedTickets={selectedTickets}
          setSelectedTickets={setSelectedTickets}
          onTicketsLoaded={(ids) => handleTicketsLoaded("closed", ids)}
          {...commonFilterProps}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {renderBulkActionsBox()}
        {profile === "admin" && (
          <>
            <TicketsList
              showAll={showAllTickets}
              selectedQueueIds={selectedQueueIds}
              status="search"
              selectedTickets={selectedTickets}
              setSelectedTickets={setSelectedTickets}
              onTicketsLoaded={(ids) => handleTicketsLoaded("search", ids)}
              {...commonFilterProps}
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            showAll={false}
            selectedQueueIds={selectedQueueIds}
            status="search"
            selectedTickets={selectedTickets}
            setSelectedTickets={setSelectedTickets}
            onTicketsLoaded={(ids) => handleTicketsLoaded("search", ids)}
            {...commonFilterProps}
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;